interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}
const PersonOutlineIcon = ({ width, height, fill }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <mask
        id="mask0_1827_28203"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1827_28203)">
        <path
          d="M9.99992 10.0002C9.08325 10.0002 8.29853 9.67377 7.64575 9.021C6.99297 8.36822 6.66659 7.5835 6.66659 6.66683C6.66659 5.75016 6.99297 4.96544 7.64575 4.31266C8.29853 3.65989 9.08325 3.3335 9.99992 3.3335C10.9166 3.3335 11.7013 3.65989 12.3541 4.31266C13.0069 4.96544 13.3333 5.75016 13.3333 6.66683C13.3333 7.5835 13.0069 8.36822 12.3541 9.021C11.7013 9.67377 10.9166 10.0002 9.99992 10.0002ZM3.33325 15.0002V14.3335C3.33325 13.8613 3.45478 13.4272 3.69784 13.0314C3.94089 12.6356 4.26381 12.3335 4.66659 12.1252C5.5277 11.6946 6.4027 11.3717 7.29159 11.1564C8.18047 10.9411 9.08325 10.8335 9.99992 10.8335C10.9166 10.8335 11.8194 10.9411 12.7083 11.1564C13.5971 11.3717 14.4721 11.6946 15.3333 12.1252C15.736 12.3335 16.0589 12.6356 16.302 13.0314C16.5451 13.4272 16.6666 13.8613 16.6666 14.3335V15.0002C16.6666 15.4585 16.5034 15.8509 16.177 16.1772C15.8506 16.5036 15.4583 16.6668 14.9999 16.6668H4.99992C4.54159 16.6668 4.14922 16.5036 3.82284 16.1772C3.49645 15.8509 3.33325 15.4585 3.33325 15.0002ZM4.99992 15.0002H14.9999V14.3335C14.9999 14.1807 14.9617 14.0418 14.8853 13.9168C14.8089 13.7918 14.7083 13.6946 14.5833 13.6252C13.8333 13.2502 13.0763 12.9689 12.3124 12.7814C11.5485 12.5939 10.7777 12.5002 9.99992 12.5002C9.22214 12.5002 8.45131 12.5939 7.68742 12.7814C6.92353 12.9689 6.16659 13.2502 5.41659 13.6252C5.29159 13.6946 5.19089 13.7918 5.1145 13.9168C5.03811 14.0418 4.99992 14.1807 4.99992 14.3335V15.0002ZM9.99992 8.3335C10.4583 8.3335 10.8506 8.1703 11.177 7.84391C11.5034 7.51752 11.6666 7.12516 11.6666 6.66683C11.6666 6.2085 11.5034 5.81613 11.177 5.48975C10.8506 5.16336 10.4583 5.00016 9.99992 5.00016C9.54158 5.00016 9.14922 5.16336 8.82284 5.48975C8.49645 5.81613 8.33325 6.2085 8.33325 6.66683C8.33325 7.12516 8.49645 7.51752 8.82284 7.84391C9.14922 8.1703 9.54158 8.3335 9.99992 8.3335Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default PersonOutlineIcon;
